import React from "react";
import { useMediaQuery } from 'react-responsive';
import WebHomeMain from './Web';
import MobileHomeMain from './Mobile';


const HomeHeader = () => {
    const isDesktop = useMediaQuery({ minWidth: 768 }); // 目前PC和平板的尺寸没有做区分
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <div>
            {isDesktop && <WebHomeMain />}
            {isMobile && <MobileHomeMain />}
        </div>
    );
};

export default HomeHeader;